{
  "version": 1,
  "zoneId": "Z03",
  "name": "The Silt Stair",
  "referenceHolder": "REE",
  "fixedGeometry": {
    "totalRiseMeters": 42,
    "authoredElevationsMeters": [0, 8, 10, 20, 22, 36, 42],
    "layoutVariesBySeed": false,
    "maintenanceLoop": [
      "beat:lift-yard",
      "beat:eastern-road-lock-foot",
      "beat:reeves-court",
      "beat:lift-yard"
    ]
  },
  "beats": [
    {
      "id": "beat:lower-landing",
      "name": "Lower Landing",
      "elevationMeters": { "min": 0, "max": 0 },
      "summary": "The outsider arrives to pursue a personal objective and finds Nessa Tal beside a waiting grain barge and an empty coffin reported as lost cargo.",
      "features": ["grain barge", "empty coffin", "porter controls", "public food stall"],
      "services": ["service:landing-food"],
      "interactions": ["interaction:state-personal-need", "interaction:inspect-empty-coffin", "interaction:speak-nessa"]
    },
    {
      "id": "beat:toll-stair",
      "name": "Toll Stair",
      "elevationMeters": { "min": 8, "max": 20 },
      "summary": "Broad ramps, a narrow workers' stair and a fixed checkpost connect the quay to town without changing when the holder changes.",
      "features": ["broad ramps", "workers' stair", "fixed checkpost"],
      "services": ["service:toll-access"],
      "interactions": ["interaction:show-credentials", "interaction:pay-posted-toll", "interaction:offer-service", "interaction:take-maintenance-path"]
    },
    {
      "id": "beat:middle-market-cold-bath",
      "name": "Market/Cold Bath",
      "elevationMeters": { "min": 22, "max": 22 },
      "summary": "Food, basic repair, contract escrow and candidates share a market around an unheated public bath where Melian Sar gives lawful treatment.",
      "features": ["middle market", "cold public bath", "treatment alcove", "drain route"],
      "services": ["service:market-food", "service:basic-repair", "service:contract-escrow", "service:companion-candidates", "service:melian-treatment"],
      "interactions": ["interaction:lawful-ritual-demonstration", "interaction:inspect-bath-drain"]
    },
    {
      "id": "beat:lift-yard",
      "name": "Lift Yard",
      "elevationMeters": { "min": 10, "max": 36 },
      "summary": "Three grain platforms, a damaged drum, tally shelter and workshop expose the bright new pin and the still-missing fitted bearing.",
      "features": ["three grain platforms", "damaged drum", "bright new pin", "tally shelter", "workshop"],
      "services": ["service:lift-inspection"],
      "interactions": ["interaction:inspect-new-pin", "interaction:inspect-fractured-bearing", "interaction:negotiate-yard-access"]
    },
    {
      "id": "beat:reeves-court",
      "name": "Reeve's Court",
      "elevationMeters": { "min": 42, "max": 42 },
      "summary": "The holder's correct official controls the lift requisition and burial concession amid older administrative layers beneath current notices.",
      "features": ["holder office", "repair requisition", "burial concession register", "older notices"],
      "services": ["service:official-hearing"],
      "interactions": ["interaction:present-independent-evidence", "interaction:request-repair-requisition"]
    },
    {
      "id": "beat:eastern-road-lock-foot",
      "name": "Eastern Road/Lock Foot",
      "elevationMeters": { "min": 10, "max": 42 },
      "summary": "The funeral road leaves for Z04 while a low sluice passage reaches a maintenance gate beneath the imperial road terrace.",
      "features": ["funeral road to Z04", "low sluice passage", "maintenance gate", "visible safety pawl", "marked water levels"],
      "services": [],
      "interactions": ["interaction:inspect-sluice-pawl", "interaction:depart-for-Z04"]
    }
  ],
  "connections": [
    { "id": "route:landing-toll", "from": "beat:lower-landing", "to": "beat:toll-stair", "twoWay": true, "kind": "broad-ramp", "nonCombat": true },
    { "id": "route:toll-market", "from": "beat:toll-stair", "to": "beat:middle-market-cold-bath", "twoWay": true, "kind": "workers-stair", "nonCombat": true },
    { "id": "route:bath-drain", "from": "beat:middle-market-cold-bath", "to": "beat:lift-yard", "twoWay": true, "kind": "authored-drain", "nonCombat": true },
    { "id": "route:lift-court", "from": "beat:lift-yard", "to": "beat:reeves-court", "twoWay": true, "kind": "grain-ramp", "nonCombat": true },
    { "id": "route:court-road", "from": "beat:reeves-court", "to": "beat:eastern-road-lock-foot", "twoWay": true, "kind": "imperial-road", "nonCombat": true },
    { "id": "route:sluice-maintenance", "from": "beat:lift-yard", "to": "beat:eastern-road-lock-foot", "twoWay": true, "kind": "sluice-side-passage", "nonCombat": true }
  ],
  "services": [
    { "id": "service:landing-food", "beatId": "beat:lower-landing", "kind": "food", "nonCombat": true, "contractId": null },
    { "id": "service:toll-access", "beatId": "beat:toll-stair", "kind": "passage", "nonCombat": true, "contractId": null },
    { "id": "service:market-food", "beatId": "beat:middle-market-cold-bath", "kind": "food", "nonCombat": true, "contractId": null },
    { "id": "service:basic-repair", "beatId": "beat:middle-market-cold-bath", "kind": "repair", "nonCombat": true, "contractId": null },
    { "id": "service:contract-escrow", "beatId": "beat:middle-market-cold-bath", "kind": "escrow", "nonCombat": true, "contractId": "contract:transshipment-crew" },
    { "id": "service:companion-candidates", "beatId": "beat:middle-market-cold-bath", "kind": "recruitment", "nonCombat": true, "contractId": null },
    { "id": "service:melian-treatment", "beatId": "beat:middle-market-cold-bath", "kind": "treatment", "nonCombat": true, "contractId": null },
    { "id": "service:lift-inspection", "beatId": "beat:lift-yard", "kind": "inspection", "nonCombat": true, "contractId": null },
    { "id": "service:official-hearing", "beatId": "beat:reeves-court", "kind": "hearing", "nonCombat": true, "contractId": null }
  ],
  "holderAccess": {
    "SEN": { "serviceId": "service:market-food", "method": "Show a registered travel purpose or accept the posted debt-backed toll.", "nonCombat": true },
    "BRZ": { "serviceId": "service:market-food", "method": "Show a transit chit or complete a named unloading service at the checkpost.", "nonCombat": true },
    "REE": { "serviceId": "service:market-food", "method": "Join the posted stair contribution or use the public workers' stair.", "nonCombat": true },
    "SAL": { "serviceId": "service:market-food", "method": "Pay the posted quay toll or present a valid berth note.", "nonCombat": true },
    "LOC": { "serviceId": "service:market-food", "method": "Ask the toll council for consent or take the open maintenance path.", "nonCombat": true }
  },
  "roleBindings": {
    "nessa": {
      "id": "role:z03-burial-porter",
      "role": "witness",
      "zone": "Z03",
      "preferredPersonId": "person:nessa-tal",
      "preferredName": "Nessa Tal",
      "alternatives": [
        {
          "kind": "person",
          "personId": "person:jessa-menn",
          "identifyingHistory": "A different burial porter owed the same missing wages and witnessed the false cart seal.",
          "prerequisites": { "all": [], "any": [], "none": [] }
        }
      ]
    },
    "melian": {
      "id": "role:z03-lawful-practitioner",
      "role": "service",
      "zone": "Z03",
      "preferredPersonId": "person:melian-sar",
      "preferredName": "Melian Sar",
      "alternatives": [
        {
          "kind": "person",
          "personId": "person:pelian-vel",
          "identifyingHistory": "A distinct licensed binder maintains the treatment alcove and can demonstrate the same lawful rite without inheriting Melian's identity.",
          "prerequisites": { "all": [], "any": [], "none": [] }
        }
      ]
    },
    "officialByHolder": {
      "SEN": {
        "id": "role:z03-official:SEN",
        "role": "leader",
        "zone": "Z03",
        "preferredPersonId": "person:clerk-ossa-vel",
        "preferredName": "Clerk Talla Vel",
        "alternatives": [{ "kind": "person", "personId": "person:averin-dareth", "identifyingHistory": "A distinct Senate registrar inherits the office docket, not Ossa Vel's identity or private history.", "prerequisites": { "all": [], "any": [], "none": [] } }]
      },
      "BRZ": {
        "id": "role:z03-official:BRZ",
        "role": "leader",
        "zone": "Z03",
        "preferredPersonId": "person:depot-sereth-kall",
        "preferredName": "Depot Officer Sereth Kall",
        "alternatives": [{ "kind": "person", "personId": "person:delvar-serrat", "identifyingHistory": "A distinct depot officer receives the requisition ledger without inheriting Sereth Kall's identity.", "prerequisites": { "all": [], "any": [], "none": [] } }]
      },
      "REE": {
        "id": "role:z03-official:REE",
        "role": "leader",
        "zone": "Z03",
        "preferredPersonId": "person:measurer-bera-nall",
        "preferredName": "Measurer Bera Nall",
        "alternatives": [{ "kind": "person", "personId": "person:arel-gath", "identifyingHistory": "A distinct canal measurer is appointed against the same lift and ration accounts without reviving Bera Nall.", "prerequisites": { "all": [], "any": [], "none": [] } }]
      },
      "SAL": {
        "id": "role:z03-official:SAL",
        "role": "leader",
        "zone": "Z03",
        "preferredPersonId": "person:factor-deren-pell",
        "preferredName": "Factor Deren Pell",
        "alternatives": [{ "kind": "person", "personId": "person:ressa-vossat", "identifyingHistory": "A distinct harbour factor assumes the public toll contract without inheriting Deren Pell's life.", "prerequisites": { "all": [], "any": [], "none": [] } }]
      },
      "LOC": {
        "id": "role:z03-official:LOC",
        "role": "leader",
        "zone": "Z03",
        "preferredPersonId": "person:speaker-maran",
        "preferredName": "Speaker Maran",
        "alternatives": [{ "kind": "person", "personId": "person:bessa-lock-foot", "identifyingHistory": "A distinct resident chosen at the Lock Foot carries the council's consent, not Maran's identity.", "prerequisites": { "all": [], "any": [], "none": [] } }]
      }
    }
  },
  "successors": [
    { "id": "person:jessa-menn", "name": "Tessa Menn", "lineageKey": "lineage:jessa-menn", "roleId": "role:z03-burial-porter" },
    { "id": "person:pelian-vel", "name": "Pelian Vel", "lineageKey": "lineage:pelian-vel", "roleId": "role:z03-lawful-practitioner" },
    { "id": "person:averin-dareth", "name": "Averin Dareth", "lineageKey": "lineage:averin-dareth", "roleId": "role:z03-official:SEN" },
    { "id": "person:delvar-serrat", "name": "Delvar Serrat", "lineageKey": "lineage:delvar-serrat", "roleId": "role:z03-official:BRZ" },
    { "id": "person:arel-gath", "name": "Orlo Gath", "lineageKey": "lineage:arel-gath", "roleId": "role:z03-official:REE" },
    { "id": "person:ressa-vossat", "name": "Imra Vossat", "lineageKey": "lineage:ressa-vossat", "roleId": "role:z03-official:SAL" },
    { "id": "person:bessa-lock-foot", "name": "Bessa of the Lock Foot", "lineageKey": "lineage:bessa-lock-foot", "roleId": "role:z03-official:LOC" }
  ],
  "tutorialDialogue": [
    {
      "id": "tutorial:state-personal-need",
      "intention": { "kind": "ask", "label": "Explain why you need the local official" },
      "text": "I came to Silt Stair to settle my own business. Which office holds the local records?",
      "disclosure": "essential",
      "firstEncounterSummary": "State the outsider's personal objective and find the holder's local official.",
      "prerequisites": { "all": [], "any": [], "none": [] },
      "effects": { "add": ["tutorial:personal-need-stated"], "remove": [] },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    },
    {
      "id": "tutorial:ask-about-empty-coffin",
      "intention": { "kind": "ask", "label": "Ask why the coffin is empty" },
      "text": "That is not lost cargo. Whose burial was this?",
      "disclosure": "essential",
      "firstEncounterSummary": "An empty coffin and Nessa's false cargo report point toward a missing burial.",
      "prerequisites": { "all": ["tutorial:personal-need-stated"], "any": [], "none": [] },
      "effects": { "add": ["slice:coffin-questioned"], "remove": [] },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    },
    {
      "id": "tutorial:read-imperial-layers",
      "intention": { "kind": "ask", "label": "Compare the old imperial notices" },
      "text": "These older assessments name a different office, but the same lift account.",
      "disclosure": "deep",
      "firstEncounterSummary": null,
      "prerequisites": { "all": ["tutorial:personal-need-stated", "location:reeves-court"], "any": [], "none": [] },
      "effects": { "add": ["lore:imperial-administrative-layer-read"], "remove": [] },
      "requiredIncentives": [],
      "requiredProtections": [],
      "socialDifficulty": null
    }
  ],
  "sluiceSafetyPawl": {
    "id": "interaction:inspect-sluice-pawl",
    "beatId": "beat:eastern-road-lock-foot",
    "visible": true,
    "markedWaterLevels": true,
    "defaultState": "engaged",
    "materialConsequence": "Disengaging the pawl can release water into the low passage, damage evidence or close the safe maintenance route; it never acts as a generic puzzle switch."
  }
}
